<script>
</script>
<div class="row">
    <div class="col-5 col-lg-7 linea">
    </div>
    <div class="col-7 col-lg-5">
        <h2>Luncheras</h2>
    </div>

</div>
<div class="row">
            <div class="col-4">
                <div class="cards">
                    <img class="card-img-top img-card" src="img/Low/bolso1.png" alt="Bolso termico IcemaGeles">
                </div>
            </div>
            <div class="col-4">
                <div class="cards">
                    <img class="card-img-top img-card" src="img/Low/bolso2.png" alt="Bolso termico IcemaGeles">
                </div>
            </div>
            <div class="col-4">
                <div class="cards">
                    <img class="card-img-top img-card" src="img/Low/bolso3.png" alt="Bolso termico IcemaGeles">
                </div>
            </div>
    <div class="col-12 top-20">
        <ul>
            <li>
                Comercializamos luncheras, mochilas y bolsos térmicos de diferentes medidas.
            </li>
        </ul>
    </div>

</div>
<style>
.card-img-top:hover{
    transform: scale(1.3);
    border: 0px;
    z-index: 100;
    align-self: center;
  }
  .cards{
    padding: 5px;
    text-align: center;
    background-color: rgba(255,255,255,0.4);
  }
  .img-card{
    max-height: 120px;
    max-width: 140px;
  }
</style>
